module.exports = __webpack_public_path__ + "static/w-hearst-877c74aef39b1ba3cc872a9cff7f73e7.webp";